<template>
  <div class='SideNaveMobi'>
    <div class="black" @click="out=true"></div>
    <div :class="{ contOut: out }" class="cont" ref="cont"
    :style="{ 
      backgroundColor: Prefes.navepainel.corBackground,
      fontFamily: Prefes.navepainel.font,
      color: Prefes.navepainel.corFont,
      fontStyle: parseInt(Prefes.navepainel.fontStyle) ? 'italic' : '',
      fontWeight: parseInt(Prefes.navepainel.fontBold) ? 'bold' : '',
      textDecoration: parseInt(Prefes.navepainel.textDecoration) ? 'underline' : '',
      fontSize: Prefes.navepainel.fontHeight + 'px'
    }"
    >
      <div class="cont-logo">
        <img :src="Logo">
      </div>
      <link-nave-mobi
      @goPage="newValue => out = newValue"
      v-for="(l, key) in Empresa.modelo !== 'Modelo 03' ? LinkSidebar : LinkSidebar.map(l => {
        if(l.text === 'Produtos') { l.text = 'Imóveis' }
        if(l.text === 'Loja') { l.text = 'Site' }
        return l
      }).filter(l => ['Imóveis', 'Preferências', 'Marketing', 'Usuários', 'Site'].includes(l.text))"
      :key="key"
      :data="l"
      />
      <link-nave-mobi
      @goPage="newValue => out = newValue"
      v-for="(l, key) in [{ text: logged ? 'Sair' : 'Login', path: '/', icon: logged ? 'LogoutIcon' : 'UserIcon01' }]"
      :key="key"
      :data="l"
      login
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LinkNaveMobi from './LinkNaveMobi'
export default {
  name: 'SideNaveMobi',
  components: { LinkNaveMobi },
  data () {
    return {
      out: false,
      end: 0,
      load: false
    }
  },
  mounted () {
    this.$refs.cont.addEventListener("animationend", this.animationEnd, false);
  },
  computed: {
    ...mapGetters(['Categorias', 'Logo', 'Profile', 'LinkSidebar', 'Prefes', 'Empresa']),
    logged () {
      return  Object.keys(this.Profile).length
    }
  },
  methods: {
    ...mapActions(['ToggleSideNave']),
    animationEnd () {
      this.end++
      if (this.end > 1) {
        this.ToggleSideNave(false)
      }
    }
  }
}
</script>

<style scoped>
.SideNaveMobi {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.black {
  width: 100%;
  height: 100%;
  opacity: 0.50;
  position: absolute;
  background-color: #000000;
}

.cont-logo {
  padding-top: 2%;
  padding-bottom: 2%;
  border-bottom: thin solid #EEEEEE;
}

img {
  width: 25%;
}

.cont {
  width: 90%;
  height: 100%;
  position: absolute;
  left: 0;
  background-color: #FFFFFF;
  animation: ShowIn 0.5s;
  overflow: auto;
}

.contOut {
  width: 0%;
  animation: ShowOut 0.3s;
}

.cont-loader {
  padding-top: 35%;
}

@keyframes ShowIn {
  from {
    width: 0%;
  }
  to {
    width: 90%;
  }
}

@keyframes ShowOut {
  from {
    width: 90%;
  }
  to {
    width: 0%;
  }
}
</style>
